import SplitBlock from './SplitBlock';

export default SplitBlock;
